export const base_path ='/'
export const img_path ='/'
export const API_URL =  process.env.REACT_APP_API_URL;
//export const API_URL = 'http://localhost:5001/dev/v1'
export const THEME: 'light' | 'dark' = 'light' // 'light' or 'dark'
export const DEFAULT_TENANT = ''
export const DEFAULT_THUMBNAIL_URL = 'https://i.ytimg.com/vi/GKVeZkrQ6XM/hq720.jpg?sqp=-%E2%80%A6GUgXChMMA8=&rs=AOn4CLAs28M0bVtLDLPlt3BvW7VSbb9Lvg'